var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFurnitureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#0058AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14H15V15.7143H5V14Z",
    fill: "#FFD700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15.1429,
    width: 0.555556,
    height: 1.14286,
    rx: 0.277778,
    fill: "#FFD700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4445,
    y: 15.1429,
    width: 0.555556,
    height: 1.14286,
    rx: 0.277778,
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 4C5.89545 4 5.00002 4.89543 5.00002 5.99999L5 13H9.44444L9.44447 4H7.00002ZM8.33333 8.2C8.0265 8.2 7.77777 8.44873 7.77777 8.75556V9.44445C7.77777 9.75127 8.0265 10 8.33333 10C8.64015 10 8.88888 9.75127 8.88888 9.44445V8.75556C8.88888 8.44873 8.64015 8.2 8.33333 8.2Z",
    fill: "#FFD700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 4C14.1045 4 14.9999 4.89543 14.9999 5.99999L14.9999 13H10.5556L10.5556 4H12.9999ZM11.6667 8.2C11.3598 8.2 11.1111 8.44873 11.1111 8.75556V9.44445C11.1111 9.75127 11.3598 10 11.6667 10C11.9735 10 12.2222 9.75127 12.2222 9.44445V8.75556C12.2222 8.44873 11.9735 8.2 11.6667 8.2Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureIcon);
export default __webpack_public_path__ + "static/media/furnitureIcon.d3273158.svg";
export { ForwardRef as ReactComponent };